import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-x4" }

import ProductSpotSwiper from '@/shared/content/blocks/helpers/ProductSpotSwiper.vue';
import {
    ProductMoreFromSameSeriesTileModel,
} from '@/types/B2CcontentServerContract';
import { computed, onMounted, watch } from 'vue';
import BlockMaxWidthHandler from '@/shared/content/blocks/helpers/BlockMaxWidthHandler.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import useProductsFromSameSeries from '@/shared/product/useProductsFromSameSeries';
import useProductDetailData from '@/shared/product/details/useProductDetailData';
import useNetPrices from '@/b2b/product/useNetPrices';
import useOutletProductDetailData from '@/shared/product/details/ui/outlet/useOutletProductDetailData';
import useElementSeen from '@/shared/navigation/useElementSeen';
import gtmService from '@/shared/tracking/gtm.service';
import { ProductSpotModel } from '@/types/productServerApi';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductMoreFromSameSeriesTile',
  props: {
    content: null
  },
  setup(__props: any) {


const { getProductsFromSameSeries, products } = useProductsFromSameSeries();
const { variantId } = useProductDetailData();
const { originalSku } = useOutletProductDetailData();
const { fetchNetPrices } = useNetPrices();

const functionRef = useElementSeen(() => gtmService.viewItemList(productsExceptMainProduct.value, { itemListId: 'more_from_same_series', itemListName: 'More From Same Series' }));

const init = async() => {
    const id = variantId.value || originalSku.value;
    await getProductsFromSameSeries(id);
};

const labels = useBlockLabels();
const productsExceptMainProduct = computed(() => products.value.filter((product) => product.sku !== variantId.value));

const handleChangedProductResult = () => {
    fetchNetPrices(productsExceptMainProduct.value.map((item) => item.sku));
};

watch(products, handleChangedProductResult, { immediate: true });

// Needs to be on mounted as initialization can be at the same time as ProductDetail or OutletProductDetail (variantId, originalSku)
onMounted(init);

const trackSelectItem = (product: ProductSpotModel, index: number) => {
    gtmService.selectItem(product, { itemListId: 'more_from_same_series', itemListName: 'More From Same Series', index });
};

return (_ctx: any,_cache: any) => {
  return (!!_unref(productsExceptMainProduct).length)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        ref: _unref(functionRef),
        class: "more-from-same-series-wrapper"
      }, [
        _createVNode(BlockMaxWidthHandler, null, {
          default: _withCtx(() => [
            _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(labels).title), 1)
          ]),
          _: 1
        }),
        _createVNode(ProductSpotSwiper, {
          "product-list": _unref(productsExceptMainProduct),
          onSelectItem: trackSelectItem
        }, null, 8, ["product-list"])
      ], 512))
    : _createCommentVNode("", true)
}
}

})